import React, { useState, useEffect, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { Routes, Route, useNavigate, useParams } from "react-router-dom";
import Axios from "axios";
import moment from "moment";

//ACTIONS
import * as GlobalVarsActions from "../../../store/actions/globalVars";
import * as UserActions from "../../../store/actions/user";
import * as RoomDetailsActions from "../../../store/actions/roomDetails";
import * as UserProfileActions from "../../../store/actions/userProfile";
import * as BookingsActions from "../../../store/actions/bookings";
import * as BookingDataActions from "../../../store/actions/bookingData";

//STYLES
import * as PortalHomeStyles from "./components/styles/portalHome";

//COMPONENTS
import MenuButton from "./components/menuButton";

import RoomView from "./frontEnd/pods/bookings/files/roomView";
import YourBookings from "./frontEnd/pods/bookings/files/yourBookings";
import OrgAdminPortal from "./admin/orgAdminPortal";
import OrganisationBookings from "./admin/pods/bookings/files/organisationBookings";
import ApproveBookings from "./frontEnd/pods/bookings/files/approveBookings";

function PortalHome() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();
    const roomBody = useRef(null);
    const roomContent = useRef(null);
    const itemBody = useRef(null);
    const itemContent = useRef(null);
    const organisation = useSelector((state) => state.organisation);
    const userProfile = useSelector((state) => state.userProfile);
    const user = useSelector((state) => state.user);
    const globalVars = useSelector((state) => state.globalVars);

    const [itemsMenu, setItemsMenu] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [roomBodyButtons, setRoomBodyButtons] = useState(false);
    const [itemBodyButtons, setItemBodyButtons] = useState(false);

    const [sizings, setSizings] = useState({
        rooms: {
            fullLenth: 0,
            heading: 0,
            buttons: 0,
            body: 0
        },
        yourItems: {
            fullLenth: 0,
            heading: 0,
            buttons: 0,
            body: 0
        }
    });

    useEffect(async () => {
        findYourItems();
        //GET START OF THE WEEK
        const date = moment().startOf("week");
        dispatch(GlobalVarsActions.UpdateTopControls_weekBG(date));

        const herfData = window.location.pathname.split("/");

        if (herfData[3] == "room") {
            const room = organisation.rooms.find((room) => room.uuid == herfData[4]);
            const layout = organisation.layouts.find((layout) => layout.uuid == room.layout);
            const daySlots = findDaySlots(layout);
            const data = await GetRoomBookings(params.orgID, herfData[4], date, daySlots);
            dispatch(BookingDataActions.UpdateBookingData(data.data, data.orgID, data.roomID, data.weekSlot, data.days, layout.days, data.weekBG));
        }
        console.log(sizings);
    }, []);

    useEffect(() => {
        setIsLoaded(true);
    }, [sizings]);

    function findYourItems() {
        const items = [{ name: "Your Bookings", followOnID: "yourBookings" }];

        if (userProfile.userSettings.administrator.orgAdminAccess) {
            items.push({ name: "Organisation Administrator", followOnID: "orgAdmin" });
        }

        if (userProfile.userSettings.bookings.viewAllOrgBookings) {
            items.push({ name: "Organisation Bookings", followOnID: "orgBookings" });
        }

        if (organisation.approvalSystemEnabled && user.bookingApprove == "true") {
            items.push({ name: "Approve Bookings", followOnID: "approveBookings" });
        }

        items.push({ name: "Log Out", followOnID: "logout" });

        setItemsMenu(items);
    }

    useEffect(() => {
        setMenuSizings();
    }, [globalVars.mainBodyHeight]);

    useEffect(() => {
        if (roomBody.current != null) {
            if (roomContent.current.offsetHeight > roomBody.current.offsetHeight) {
                setRoomBodyButtons(true);
            }
        }
    }, [roomBody.current]);

    useEffect(() => {
        if (itemBody.current != null) {
            if (itemContent.current.offsetHeight > itemBody.current.offsetHeight) {
                setItemBodyButtons(true);
            }
        }
    }, [itemBody.current]);

    function setMenuSizings() {
        let roomsLength = globalVars.body10thHeight * 6;
        let yourItemsLength = globalVars.body10thHeight * 4;
        setSizings({
            rooms: {
                fullLenth: roomsLength,
                heading: 30,
                buttons: 30,
                body: roomsLength - 90
            },
            yourItems: {
                fullLenth: yourItemsLength,
                heading: 30,
                buttons: 30,
                body: yourItemsLength - 90
            }
        });
    }

    async function handleRoomSelection(roomID) {
        const room = organisation.rooms.find((room) => room.uuid == roomID);
        const layout = organisation.layouts.find((layout) => layout.uuid == room.layout);
        const daySlots = findDaySlots(layout);
        const data = await GetRoomBookings(params.orgID, roomID, globalVars.topControls.weekBG, daySlots);
        dispatch(BookingDataActions.UpdateBookingData(data.data, data.orgID, data.roomID, data.weekSlot, data.days, layout.days, data.weekBG));
        navigate(`./room/${roomID}`);
    }

    function findDaySlots(layout) {
        const daySlots = [];
        const days = layout.days.split(",");

        if (layout.layout == "Diary") {
            const ti = [];
            const start = moment(layout.startTime, "HH:mm");
            const finish = moment(layout.finishTime, "HH:mm");

            while (start.isBefore(finish)) {
                ti.push(start.format("HH:mm"));
                start.add(layout.timeInterval, "m");
            }

            for (const [index, day] of days.entries()) {
                if (day == "true") {
                    for (const time of ti) {
                        daySlots.push(`${formatString(index)}-${time.replace(":", "")}`);
                    }
                }
            }
        }
        if (layout.layout == "Timetable") {
            const order = layout.sessionOrder.split(",");
            console.log(order);

            for (const [index, day] of days.entries()) {
                if (day == "true") {
                    for (const session of order) {
                        daySlots.push(`${formatString(index)}-${formatString(session)}`);
                    }
                }
            }
        }

        return daySlots;
    }

    function handleItemSelection(followOnID) {
        if (followOnID == "logout") {
            Axios.post("/userLogin/logout")
                .then((res) => {
                    console.log(res.data.message);
                    if (res.data.message === "User logged out") {
                        let page;
                        if (user.role == "superAdmin") {
                            page = "/";
                        } else {
                            const orgID = user.orgID;
                            page = "/org/" + orgID + "/security/signIn";
                        }
                        dispatch(UserActions.userUpdateAuth(false));
                        dispatch(UserActions.userUpdateName(""));
                        dispatch(UserActions.userUpdateRole(""));
                        dispatch(UserActions.userUpdateNew(""));
                        dispatch(UserActions.userUpdateRequestedPassword(false));
                        dispatch(UserActions.userUpdateUserDepartments([]));
                        dispatch(UserActions.userUpdateOrgID(""));
                        dispatch(BookingsActions.UpdateBookingDetails(false));
                        dispatch(RoomDetailsActions.UpdateShowSwitch(false));
                        dispatch(UserProfileActions.ResetState());
                        navigate(page);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            dispatch(GlobalVarsActions.UpdateMenuTransition("all 0.2s ease-out"));
            navigate(`./${followOnID}`);
        }
    }

    function handleRoomBodyDown() {
        roomBody.current.scrollTo(0, roomBody.current.scrollTop + 30);
    }

    function handleRoomBodyUp() {
        roomBody.current.scrollTo(0, roomBody.current.scrollTop - 30);
    }

    function handleItemBodyDown() {
        itemBody.current.scrollTo(0, itemBody.current.scrollTop + 30);
    }

    function handleItemBodyUp() {
        itemBody.current.scrollTo(0, itemBody.current.scrollTop - 30);
    }

    return (
        <div>
            {isLoaded && (
                <div style={{ height: `${globalVars.mainBodyHeight}px` }}>
                    <Row style={{ height: `${globalVars.mainBodyHeight}px`, margin: "0" }}>
                        <Col sm={2}>
                            {globalVars.mainBodyHeight == 0 ? (
                                <div>
                                    <strong>Loading...</strong>
                                </div>
                            ) : (
                                <div>
                                    <Row style={{ borderRight: "1px solid black", height: `${sizings.rooms.fullLenth}px` }}>
                                        <Col style={{ height: "100%" }}>
                                            <Row style={{ height: `${sizings.rooms.heading}px` }}>
                                                <Col style={{ fontWeight: "bold" }}>
                                                    <div>Your Rooms: </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col style={{ height: `${sizings.rooms.buttons}px` }}>
                                                    {roomBodyButtons && (
                                                        <div style={PortalHomeStyles.navigationButtons} onClick={handleRoomBodyUp}>
                                                            <i className="fa-solid fa-chevron-up"></i>
                                                        </div>
                                                    )}
                                                </Col>
                                            </Row>
                                            <Row style={{ height: `${sizings.rooms.body}px` }}>
                                                <Col ref={roomBody} style={{ height: "100%", overflowY: "scroll" }}>
                                                    <div ref={roomContent}>
                                                        {organisation.rooms.map((room, index) => {
                                                            const UPRoom = userProfile.rooms.find((ro) => room.uuid == ro.roomUUID);
                                                            if (UPRoom.prop_View == "true") {
                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        style={{ marginTop: "5px" }}
                                                                        className={
                                                                            globalVars.mainMenu.menu == "rooms" &&
                                                                            globalVars.mainMenu.followOnID == room.uuid
                                                                                ? "mainMenu_buttonSelected"
                                                                                : "mainMenu_button"
                                                                        }
                                                                        onClick={handleRoomSelection.bind(this, room.uuid)}
                                                                    >
                                                                        {room.name}
                                                                    </div>
                                                                );
                                                            }
                                                        })}
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col style={{ height: `${sizings.rooms.buttons}px` }}>
                                                    {roomBodyButtons && (
                                                        <div style={PortalHomeStyles.navigationButtons} onClick={handleRoomBodyDown}>
                                                            <i className="fa-solid fa-chevron-down"></i>
                                                        </div>
                                                    )}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row
                                        style={{
                                            borderTop: "1px solid black",
                                            borderRight: "1px solid black",
                                            height: `${sizings.yourItems.fullLenth}px`
                                        }}
                                    >
                                        <Col style={{ height: "100%" }}>
                                            <Row style={{ height: `${sizings.yourItems.heading}px` }}>
                                                <Col style={{ fontWeight: "bold" }}>
                                                    <div>Your Items:</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col style={{ height: `${sizings.yourItems.buttons}px` }}>
                                                    {itemBodyButtons && (
                                                        <div style={PortalHomeStyles.navigationButtons} onClick={handleItemBodyUp}>
                                                            <i className="fa-solid fa-chevron-up"></i>
                                                        </div>
                                                    )}
                                                </Col>
                                            </Row>
                                            <Row style={{ height: `${sizings.yourItems.body}px` }}>
                                                <Col ref={itemBody} style={{ height: "100%", overflowY: "scroll" }}>
                                                    <div ref={itemContent}>
                                                        {itemsMenu.map((item, index) => {
                                                            return (
                                                                <MenuButton
                                                                    key={index}
                                                                    title={item.name}
                                                                    menu={"items"}
                                                                    followOnID={item.followOnID}
                                                                    click={handleItemSelection}
                                                                />
                                                            );
                                                        })}
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col style={{ height: `${sizings.yourItems.buttons}px` }}>
                                                    {itemBodyButtons && (
                                                        <div style={PortalHomeStyles.navigationButtons} onClick={handleItemBodyDown}>
                                                            <i className="fa-solid fa-chevron-down"></i>
                                                        </div>
                                                    )}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </Col>
                        <Col sm={10} style={{ padding: "0", height: `${globalVars.mainBodyHeight}px` }}>
                            <Routes>
                                <Route path="/room/:id" element={<RoomView />} />
                                <Route path="/yourBookings" element={<YourBookings />} />
                                <Route path="/orgBookings" element={<OrganisationBookings />} />
                                <Route path="/approveBookings" element={<ApproveBookings />} />
                                <Route path="/orgAdmin/*" element={<OrgAdminPortal debug={"10px"} />} />
                            </Routes>
                        </Col>
                    </Row>
                </div>
            )}
        </div>
    );
}

function formatString(time) {
    if (time.toString().includes("b")) {
        time = time.replace("b", "");

        if (time.toString().length == 1) {
            return "b0" + time;
        } else {
            return time;
        }
    } else {
        if (time.toString().length == 1) {
            return "0" + time;
        } else {
            return time;
        }
    }
}

export function GetRoomBookings(orgID, roomID, weekBG, days) {
    return new Promise((resolve, reject) => {
        const weekSlot = formatString(weekBG.week()) + "-" + weekBG.format("YY");

        const mySQLData = {
            orgID: orgID,
            room: roomID,
            week: weekSlot,
            days: days,
            weekBG: weekBG.format("DD/MM/YYYY")
        };
        Axios.post("/bookings/getBookings", mySQLData)
            .then((res) => {
                // console.log(res.data.bookings);
                resolve({
                    data: res.data.bookings,
                    orgID: orgID,
                    roomID: roomID,
                    weekSlot: weekSlot,
                    days: days,
                    weekBG: weekBG
                });
            })
            .catch((err) => {
                console.log(err);
            });
    });
}

export default PortalHome;
